import { AU_LOCALE } from '@eb/intl';
import {
    CONTACT_US_TEXT,
    PACKAGE_COMPARISON_PAGE,
    UPDATE_TEXT,
    UPGRADE_TEXT,
} from '../../constants/main';
import * as featuresComparison from '../../constants/featuresComparison';
import { STYLE_ANCHOR } from 'eventbrite_design_system/button/constants';

export const FEATURE_FLAG_OVERRIDES = {
    [AU_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES_AU,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES_AU,
                },
            },
            CTAs: [UPDATE_TEXT, UPGRADE_TEXT, CONTACT_US_TEXT],
            CTAStyles: [STYLE_ANCHOR, STYLE_ANCHOR, STYLE_ANCHOR],
        },
    },
};
